export default "__VITE_PUBLIC_ASSET__7013dedc__"